export default {
  FETCH_NAV_DATA: 'nav/fetch_data',
  HAMBURGER_WIDGET_SUCCESS: 'navigation/hamburger_widget_success',
};
